import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";

export async function initNative(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const dark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    await StatusBar.setStyle({ style: dark ? Style.Dark : Style.Light });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: dark ? "#020617" : "#FFFFFF" });
    }
  } catch {
  }

  App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });

  setTimeout(() => {
    SplashScreen.hide({ fadeOutDuration: 200 }).catch(() => {  });
  }, 50);
}
